import React from 'react'

interface IProps {
    className?: string
    checked: boolean
    disabled?: boolean
    ariaLabel?: string
    ariaDescribedBy?: string
    onChange?: (checked: boolean) => void
}

const Toggle: React.FC<IProps> = ({ className, checked, disabled = false, ariaLabel, ariaDescribedBy, onChange }) => {
    return (
        <button
            type={'button'}
            role={'switch'}
            aria-checked={checked}
            aria-label={ariaLabel}
            aria-describedby={ariaDescribedBy}
            disabled={disabled}
            className={`ui-toggle ${checked ? 'ui-toggle--on' : ''} ${className || ''}`}
            onClick={() => onChange?.(!checked)}>
            <span className={'ui-toggle__track'}>
                <span className={'ui-toggle__knob'} />
            </span>
        </button>
    )
}

export default Toggle
